import React from "react"

import TasksView_Column from "../../../../../../model2/column/column"
import {
    AggregateFunctionLabel,
    AggregateFunctionType
} from "../../../../../../data-structures/aggregators/types"
import AggregateShellComponent from "../../../../../../gd-modules/common/aggregate/aggregate-shell"

type Props = {
    column                      : TasksView_Column
    value                       : any

    isFirstInBlock?             : boolean
    isLastInBlock?              : boolean

    onChangeAggregateFunction   : {(aggregateFunction: AggregateFunctionType): void}
}

// const debug = "FieldCurrency_AggregateCell"
const debug = false

export default function FieldCurrency_AggregateCell(props: Props) {

    const isValid = !_.isNil(props.value) && !_.isNaN(props.value)

    let decimalPlaces = 2
    let currencyMark

    // If the column is a custom field, use its decimal places/currency symbol
    if (props.column.isCustomField) {
        decimalPlaces = props.column.customField?.params.decimalPlaces || 0

        const currencyId = props.column.customField?.params.symbol || null
        currencyMark = currencyId && gd.const.currency[currencyId] ? gd.const.currency[currencyId].symbol : null
    }

    // If custom field currency not set, use company default
    if (!currencyMark) {
        currencyMark = gd.const.currency[gd.company.financeCurrency].symbol
    }

    // Round the value for display, applying decimal places, or set null if invalid
    const value = isValid ? gd.utils.roundToDecimals(props.value, decimalPlaces) : null

    // Ensure value is in number type for formatting and fallback to parseFloat for strings
    let normalized
    if (isValid) {
        normalized = typeof value === 'number' ? value : parseFloat(value)
    } else {
        normalized = 0
    }

    // Format the value for display: thousands grouped, fixed decimals
    const valueLabel = normalized.toLocaleString(
        'en',
        {
            useGrouping             : true,
            minimumFractionDigits   : decimalPlaces,
            maximumFractionDigits   : decimalPlaces
        }
    )

    /*// Determine label to show when there is no data, depending on the aggregate function type
    let noDataLabel
    switch (props.column.aggregateFunction) {
        case AggregateFunctionType.SUM:
            noDataLabel = '0'
            break

        default:
            noDataLabel = props.column.aggregateFunction
                ? AggregateFunctionLabel[props.column.aggregateFunction]
                : ''
            break
    }*/

    // Get available aggregate function options for this field, if any
    const options = props.column.field?.getAggregateOptions()

    debug && console.log(debug, 'render', valueLabel, value, props.value)

    return (
        <AggregateShellComponent
            options                     = {options}
            noData                      = {!isValid}
            hint                        = {currencyMark + ' ' + valueLabel}
            aggregateFunction           = {props.column.aggregateFunction as string}
            isFirstInBlock              = {!!props.isFirstInBlock}
            isLastInBlock               = {!!props.isLastInBlock}
            onChangeAggregateFunction   = {props.onChangeAggregateFunction}
        >
            <>
                <div className="aggregate-label">
                    {AggregateFunctionLabel[props.column.aggregateFunction!]}:
                </div>
                <div className="aggregate-value aggregate-number">
                    {currencyMark} {valueLabel}
                </div>
            </>
        </AggregateShellComponent>
    )
}
